import { color, spacing } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import { Box } from "../../Box";
import { config } from "../config";
export const Bobbale = styled(Box) `
  border: ${config.borderSize} solid ${color.base.white};
  border-radius: ${config.size};
  height: ${config.size};
  min-width: ${config.size};

  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing.base.xs};

  &.error {
    background-color: ${color.status.error.default};
  }

  &.warning {
    background-color: ${color.status.warning.default};
  }

  &.info {
    background-color: ${color.status.info.default};
  }

  &.success {
    background-color: ${color.status.success.default};
  }
`;
export const BobbaleContainer = styled(Box) `
  position: absolute;
  top: ${(p) => {
    const offset = typeof p.offset === "number"
        ? p.offset
        : p.offset?.top
            ? p.offset.top
            : undefined;
    return offset ? `calc(${config.size} * ${offset})` : undefined;
}};
  right: ${(p) => {
    const offset = typeof p.offset === "number"
        ? p.offset
        : p.offset?.right
            ? p.offset.right
            : undefined;
    return offset ? `calc(${config.size} * ${offset})` : undefined;
}};
  bottom: ${(p) => {
    const offset = typeof p.offset !== "number" && p.offset?.bottom
        ? p.offset.bottom
        : undefined;
    return offset ? `calc(${config.size} * ${offset})` : undefined;
}};
  left: ${(p) => {
    const offset = typeof p.offset !== "number" && p.offset?.left
        ? p.offset.left
        : undefined;
    return offset ? `calc(${config.size} * ${offset})` : undefined;
}};
`;
//# sourceMappingURL=data:application/json;base64,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